import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
  Table,
} from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery } from "react-query";
import { CATEGORIES, REPORTS, USERS } from "../../config/apiConfig";
import { formatToReal } from "../../utils/utils";
import { IoMdSearch } from "react-icons/io";
import EmptyTable from "./EmptyTable";
import { MdOutlineAttachMoney, MdOutlinePageview } from "react-icons/md";
import { BsFillBarChartFill } from "react-icons/bs";
import DrawerLoading from "../DrawerLoading";
import TableLoading from "../TableLoading";
import { useApplication } from "../../contexts/ApplicationContext";
import { Tooltip } from "react-tooltip";
import { useReactToPrint } from "react-to-print";
import { FaArrowRight, FaFilter, FaPrint } from "react-icons/fa";
import { LuFilter, LuFilterX } from "react-icons/lu";
import SelectedQueryReview from "../common/query/SelectedQueryReview";

const ReportTable = () => {
  const { user } = useApplication();
  const [activeTab, setActiveTab] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPriceSum, setTotalPriceSum] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [selectedQueries, setSelectedQueries] = useState([]);
  const [listCategoryQueries, setListCategoryQueries] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [dataQuery, setDataQuery] = useState(null);
  const [selectedQuery, setSelectedQuery] = useState(0);
  const [selectedQueryReview, setSelectedQueryReview] = useState(null);
  const [shouldAutoPrint, setShouldAutoPrint] = useState(false);
  const printRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef: printRef });
  const [showFilters, setShowFilters] = useState(true);
  const [renderFilters, setRenderFilters] = useState(false);

  useEffect(() => {
    if (showFilters) {
      setRenderFilters(true); // mostra o conteúdo imediatamente
    } else {
      // espera a animação terminar antes de esconder
      const timeout = setTimeout(() => setRenderFilters(false), 500); // mesmo tempo da transition
      return () => clearTimeout(timeout);
    }
  }, [showFilters]);

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const activeFiltersCount =
    (startDate || endDate ? 1 : 0) + (selectedStatuses.length ? 1 : 0);

  const {
    isLoading: isLoadingQueryPermissions,
    error: errorQueryPermissions,
    data: userQueryPermissions,
  } = useQuery(["userQueryPermissions"], async () => {
    const { data: items } = await axios.get(
      `${USERS.GET_USER_QUERY_PERMISSIONS}`
    );

    return items?.data?.map((query) => query.id);
  });

  const {
    isLoading: isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(["categories", currentPage], async () => {
    const { data } = await axios.get(`${CATEGORIES.GET_ALL}`);

    return data.data.data;
  });

  const {
    isLoading: isLoadingReportQueries,
    error: errorListReportQueries,
    data: listReportQueries,
  } = useQuery(
    [
      "listReportQueries",
      startDate,
      endDate,
      currentPage,
      selectedQueries,
      selectedStatuses,
      nameParam,
    ],
    async () => {
      const { data } = await axios.get(
        `${REPORTS.GET_COMPANY_QUERIES_HISTORY}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&queries=${selectedQueries}&search=${nameParam}`
      );

      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalPriceSum);
      setTotalCount(data.data.totalCount);

      return data.data.data;
    }
  );

  const {
    isLoading: isLoadingReportSimplifiedQueries,
    error: errorListReportSimplifiedQueries,
    data: listReportSimplifiedQueries,
  } = useQuery(
    [
      "listReportSimplifiedQueries",

      startDate,
      endDate,
      currentPage,
      selectedQueries,
      selectedStatuses,
    ],
    async () => {
      const { data } = await axios.get(
        `${REPORTS.GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&queries=${selectedQueries}&isModular=false`
      );

      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalSumPrice || 0);
      setTotalCount(data.data.totalSumCount);

      return data.data.data;
    },
    {
      enabled: activeTab === 1,
    }
  );

  const handleCheckboxChange = (status, setState) => {
    setState((prev) =>
      prev.includes(status)
        ? prev.filter((item) => item !== status)
        : [...prev, status]
    );
  };

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  const openQueryReview = (query, autoPrint = false) => {
    setSelectedQueryReview(query);
    setDataQuery(query.data);
    setOpenModal(true);
    setShouldAutoPrint(autoPrint);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  useEffect(() => {
    setListCategoryQueries(() =>
      categories?.map((category) => {
        return {
          ...category,
          Queries: category?.Queries?.filter((query) =>
            userQueryPermissions?.includes(query.id)
          ),
        };
      })
    );
  }, [userQueryPermissions, categories]);

  // const handleDownloadPDF = async (index, fileName) => {
  //   setLoadingDownload(true);
  //   setActiveIndexLoading(index);

  //   try {
  //     const dataFile = await axios.get(
  //       `/query/download/pdf?fileName=${fileName}`
  //     );
  //     const link = document.createElement("a");
  //     link.href = dataFile.data.fileUrl;
  //     link.setAttribute("download", fileName);
  //     link.setAttribute("target", "_blank");
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (error) {
  //     console.error("Erro ao iniciar o download:", error);
  //   } finally {
  //     setLoadingDownload(false);
  //     setActiveIndexLoading(null);
  //   }
  // };

  return (
    <div
      className="relative space-y-5"
      style={{
        "--rt-ink": "#0b1220",
        "--rt-muted": "#475569",
        "--rt-border": "#e2e8f0",
        "--rt-surface": "#ffffff",
        "--rt-surface-alt": "#f8fafc",
        "--rt-accent": "#0f172a",
        "--rt-accent-2": "#1f2937",
      }}
    >
      <section className="relative overflow-hidden rounded-2xl border border-[var(--rt-border)] bg-[var(--rt-surface)] shadow-sm">
        <div className="absolute -right-16 -top-20 h-52 w-52 rounded-full bg-slate-100" />
        <div className="absolute right-10 top-6 h-28 w-28 rounded-full bg-slate-200/70" />
        <div className="relative z-10 flex flex-col gap-4 p-5 md:p-6">
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <div className="space-y-1">
              <div className="text-[10px] font-semibold tracking-[0.25em] text-slate-500">
                RELATÓRIOS
              </div>
              <div className="text-xl md:text-2xl font-semibold text-[var(--rt-ink)]">
                Histórico de consultas
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {!showFilters && (
                <Button
                  size="xs"
                  onClick={() => setShowFilters(true)}
                  className="bg-[var(--rt-accent)] hover:bg-[var(--rt-accent-2)] text-white border border-transparent shadow-sm transition-all"
                >
                  <div className="flex items-center gap-2">
                    <span>Mostrar filtros</span>
                    <span className="transition-transform duration-300">
                      <LuFilter />
                    </span>
                  </div>
                </Button>
              )}
              {activeFiltersCount > 0 && (
                <Badge className="bg-slate-100 text-slate-700 border border-slate-200 text-[10px]">
                  {activeFiltersCount} filtro
                  {activeFiltersCount > 1 ? "s" : ""} ativo
                  {activeFiltersCount > 1 ? "s" : ""}
                </Badge>
              )}
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2 text-xs text-slate-600">
            <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1">
              <span className="h-2 w-2 rounded-full bg-emerald-500" />
              {startDate && endDate
                ? `Período: ${moment(startDate).format(
                    "DD/MM/yyyy"
                  )} a ${moment(endDate).format("DD/MM/yyyy")}`
                : "Defina um período para consolidar os dados"}
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1">
              <span className="h-2 w-2 rounded-full bg-slate-400" />
              {activeTab === 0
                ? "Relatório detalhado"
                : "Relatório simplificado"}
            </span>
          </div>
        </div>
      </section>

      <div className="flex flex-col gap-4">
        {showFilters && (
          <div className="transition-all duration-500 ease-in-out overflow-hidden rounded-2xl border border-[var(--rt-border)] bg-[var(--rt-surface)] p-4 md:p-5 shadow-sm relative">
            {renderFilters && (
              <div className="transition-opacity duration-500 min-w-[200px] space-y-3">
                {(isLoadingCategories || isLoadingQueryPermissions) && (
                  <DrawerLoading />
                )}
                <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                  <div className="flex items-center gap-2">
                    <div className="text-sm font-semibold text-[var(--rt-ink)]">
                      Filtro avançado
                    </div>
                    <span className="hidden md:inline text-xs text-slate-500">
                      Refine por período e status
                    </span>
                  </div>
                  <Button
                    size="xs"
                    onClick={() => setShowFilters(false)}
                    className="bg-slate-100 text-slate-700 border border-slate-200 hover:bg-slate-200 shadow-sm transition-all"
                  >
                    <div className="flex items-center gap-2">
                      <span>Esconder filtros</span>
                      <LuFilterX />
                    </div>
                  </Button>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                  <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-3">
                    <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                      Período
                    </div>
                    <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2">
                      <label className="text-[11px] text-slate-600">
                        De
                        <input
                          type="date"
                          value={startDate}
                          onChange={(e) => {
                            setStartDate(e.target.value);
                            if (
                              moment(e.target.value).isAfter(moment(endDate))
                            ) {
                              setEndDate(e.target.value);
                            }
                          }}
                          className="mt-1 w-full block py-1.5 px-2 rounded-lg text-[11px] text-slate-700 bg-white border border-slate-200 appearance-none focus:outline-none focus:ring-2 focus:ring-slate-200"
                        />
                      </label>
                      <label className="text-[11px] text-slate-600">
                        Até
                        <input
                          type="date"
                          value={endDate}
                          onChange={(e) => {
                            setEndDate(e.target.value);
                          }}
                          min={startDate}
                          className="mt-1 w-full block py-1.5 px-2 rounded-lg text-[11px] text-slate-700 bg-white border border-slate-200 appearance-none focus:outline-none focus:ring-2 focus:ring-slate-200"
                        />
                      </label>
                    </div>
                  </div>
                  <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-3">
                    <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                      Status
                    </div>
                    <div className="mt-2 flex flex-wrap gap-2">
                      <label className="flex items-center gap-2 text-[11px] text-slate-700">
                        <Checkbox
                          id="sucesso"
                          checked={selectedStatuses.includes(1)}
                          onChange={() =>
                            handleCheckboxChange(1, setSelectedStatuses)
                          }
                        />
                        <span>Sucesso</span>
                      </label>
                      <label className="flex items-center gap-2 text-[11px] text-slate-700">
                        <Checkbox
                          id="falha"
                          checked={selectedStatuses.includes(0)} // 0 = Falha
                          onChange={() =>
                            handleCheckboxChange(0, setSelectedStatuses)
                          }
                        />
                        <span>Falha</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="flex-1 space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div className="text-sm font-semibold text-[var(--rt-ink)]">
              Resultado da busca
            </div>
            {startDate && endDate && (
              <Badge className="bg-slate-100 text-slate-700 border border-slate-200">
                {moment(startDate).format("DD/MM/yyyy")} -{" "}
                {moment(endDate).format("DD/MM/yyyy")}
              </Badge>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-gradient-to-br from-white via-slate-50 to-slate-100/40 p-4 md:p-5 shadow-sm">
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                    Valor total
                  </div>
                  <div className="mt-2 text-2xl font-semibold text-[var(--rt-ink)] flex items-center gap-2">
                    {!isLoadingReportQueries ? (
                      `${formatToReal(totalPriceSum)}`
                    ) : (
                      <div
                        role="status"
                        className="max-w-sm animate-pulse inline"
                      >
                        <div className="h-7 bg-slate-200 rounded-full w-40"></div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm">
                  <MdOutlineAttachMoney className="text-xl" />
                </div>
              </div>
              <div className="mt-3 text-[11px] text-slate-500">
                Soma dos valores no período filtrado.
              </div>
              <div className="absolute -right-16 -bottom-16 h-32 w-32 rounded-full bg-white/70" />
              <div className="absolute right-10 bottom-6 h-10 w-10 rounded-full bg-slate-200/50" />
            </div>
            <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-gradient-to-br from-white via-slate-50 to-slate-100/40 p-4 md:p-5 shadow-sm">
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                    Total de consultas
                  </div>
                  <div className="mt-2 text-2xl font-semibold text-[var(--rt-ink)]">
                    {!isLoadingReportQueries ? (
                      `${totalCount}`
                    ) : (
                      <div
                        role="status"
                        className="max-w-sm animate-pulse inline"
                      >
                        <div className="h-7 bg-slate-200 rounded-full w-40"></div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm">
                  <BsFillBarChartFill className="text-lg" />
                </div>
              </div>
              <div className="mt-3 text-[11px] text-slate-500">
                Quantidade total registrada no período.
              </div>
              <div className="absolute -right-16 -bottom-16 h-32 w-32 rounded-full bg-white/70" />
              <div className="absolute right-10 bottom-6 h-10 w-10 rounded-full bg-slate-200/50" />
            </div>
            {user?.Company?.typePayment === "POS" && (
              <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-gradient-to-br from-white via-slate-50 to-slate-100/40 p-4 md:p-5 shadow-sm">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                      Consumação mínima (VCM)
                    </div>
                    <div className="mt-2 text-2xl font-semibold text-[var(--rt-ink)] flex items-center gap-2">
                      {user?.Company?.vcm
                        ? formatToReal(user?.Company?.vcm)
                        : "-"}
                    </div>
                  </div>
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm">
                    <MdOutlineAttachMoney className="text-xl" />
                  </div>
                </div>
                <div className="mt-3 text-[11px] text-slate-500">
                  Valor mínimo de consumação contratada.
                </div>
                <div className="absolute -right-16 -bottom-16 h-32 w-32 rounded-full bg-white/70" />
                <div className="absolute right-10 bottom-6 h-10 w-10 rounded-full bg-slate-200/50" />
              </div>
            )}
          </div>
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-center gap-2">
              <span className="text-xs font-semibold text-slate-600">
                Visualizar relatório:
              </span>
              <div className="inline-flex rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
                <button
                  type="button"
                  className={`px-4 py-2 text-xs font-semibold rounded-lg transition-all ${
                    activeTab === 0
                      ? "bg-[var(--rt-accent)] text-white shadow-sm"
                      : "text-slate-600 hover:text-slate-900"
                  }`}
                  onClick={() => setActiveTab(0)}
                >
                  Detalhado
                </button>
                <button
                  type="button"
                  className={`px-4 py-2 text-xs font-semibold rounded-lg transition-all ${
                    activeTab === 1
                      ? "bg-[var(--rt-accent)] text-white shadow-sm"
                      : "text-slate-600 hover:text-slate-900"
                  }`}
                  onClick={() => setActiveTab(1)}
                >
                  Simplificado
                </button>
              </div>
            </div>
            {activeTab === 0 && (
              <form
                className="flex w-full lg:max-w-md items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 shadow-sm"
                onSubmit={handleSearchName}
              >
                <IoMdSearch className="text-slate-400" />
                <input
                  type="text"
                  placeholder="Busque por parâmetro da consulta..."
                  className="border-0 bg-transparent text-sm focus:outline-none focus:ring-0 w-full placeholder:text-slate-400"
                  onChange={(e) => setSearchName(e.target.value)}
                  value={searchName}
                />
                <Button
                  size="xs"
                  className="flex items-center bg-[var(--rt-accent)] hover:bg-[var(--rt-accent-2)]"
                  type="submit"
                >
                  Buscar
                </Button>
              </form>
            )}
          </div>

          <small className="mt-4 mb-1 flex md:hidden items-center justify-center gap-2 text-[11px] text-slate-500">
            <span>Deslize para o lado para ver todas as informações</span>
            <FaArrowsLeftRight />
          </small>
          {activeTab === 0 ? (
            <>
              {listReportQueries?.length > 0 || isLoadingReportQueries ? (
                <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm mt-0 md:mt-5">
                  <Table className="text-[13px]">
                    <Table.Head className="bg-slate-50">
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Data
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Consulta
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Valor
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Parâmetro
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Usuário
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Status
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Ações
                      </Table.HeadCell>
                    </Table.Head>

                    <Table.Body className="divide-y divide-slate-200">
                      {!isLoadingReportQueries ? (
                        <>
                          {listReportQueries?.length > 0 && (
                            <>
                              {listReportQueries.map((query, index) => (
                                <Table.Row
                                  key={index}
                                  className="bg-white hover:bg-slate-50/60 transition-colors"
                                >
                                  <Table.Cell className="font-medium text-slate-700 text-center py-2 text-2xs">
                                    {moment(query.createdAt).format(
                                      "DD/MM/yyyy | HH:mm"
                                    )}
                                    h
                                  </Table.Cell>
                                  <Table.Cell className="text-slate-900 text-center py-2 text-2xs font-semibold">
                                    {query.queryName}
                                  </Table.Cell>
                                  <Table.Cell className="font-medium text-slate-700 text-center py-2">
                                    {formatToReal(query?.price || 0)}
                                  </Table.Cell>
                                  <Table.Cell className="font-medium text-slate-700 text-center py-2">
                                    {query.parameter}
                                  </Table.Cell>
                                  <Table.Cell
                                    className="text-center py-2 max-w-[180px] truncate text-slate-700"
                                    title={query.userName}
                                  >
                                    {query.userName}
                                  </Table.Cell>
                                  <Table.Cell className="text-center py-2">
                                    {query.isSuccess ? (
                                      <Badge
                                        color="success"
                                        className="w-fit mx-auto text-xs"
                                      >
                                        Sucesso
                                      </Badge>
                                    ) : (
                                      <Badge
                                        color="failure"
                                        className="w-fit mx-auto text-xs"
                                      >
                                        Falha
                                      </Badge>
                                    )}
                                  </Table.Cell>
                                  <Table.Cell className="text-center py-2">
                                    <div className="flex gap-2 justify-center">
                                      {query?.isSuccess && (
                                        <>
                                          <Tooltip
                                            id="tooltip-save"
                                            content={`Visualizar consulta`}
                                          />
                                          <MdOutlinePageview
                                            data-tooltip-id="tooltip-save"
                                            className="cursor-pointer text-slate-600 hover:text-slate-900 transition-colors"
                                            fontSize={26}
                                            onClick={() =>
                                              openQueryReview(query, false)
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </Table.Cell>
                                </Table.Row>
                              ))}
                            </>
                          )}
                        </>
                      ) : (
                        <TableLoading cols={7} />
                      )}
                    </Table.Body>
                  </Table>
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          ) : (
            <>
              {listReportSimplifiedQueries?.length > 0 ||
              isLoadingReportSimplifiedQueries ? (
                <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm mt-0 md:mt-5">
                  <Table className="text-[13px]">
                    <Table.Head className="bg-slate-50">
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Produto/Consulta
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Qtd. Total
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-slate-50 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Valor Total
                      </Table.HeadCell>
                    </Table.Head>

                    <Table.Body className="divide-y divide-slate-200">
                      {!isLoadingReportSimplifiedQueries ? (
                        <>
                          {listReportSimplifiedQueries?.length > 0 && (
                            <>
                              {listReportSimplifiedQueries.map(
                                (query, index) => (
                                  <Table.Row
                                    key={index}
                                    className="bg-white hover:bg-slate-50/60 transition-colors"
                                  >
                                    <Table.Cell className="font-medium text-slate-700 text-center py-2">
                                      {query.queryName}
                                    </Table.Cell>
                                    <Table.Cell className="font-medium text-slate-700 text-center py-2">
                                      {query.count}
                                    </Table.Cell>
                                    <Table.Cell className="font-medium text-slate-700 text-center py-2">
                                      {formatToReal(query?.totalPrice || 0)}
                                    </Table.Cell>
                                  </Table.Row>
                                )
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <TableLoading cols={3} />
                      )}
                    </Table.Body>
                  </Table>
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          )}

          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-3">
              <div className="rounded-xl border border-slate-200 bg-white px-2 py-1 shadow-sm">
                <Pagination
                  layout="pagination"
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={onPageChange}
                  previousLabel=""
                  nextLabel=""
                  showIcons
                />
              </div>
            </div>
          )}
        </div>
        <Modal
          show={openModal}
          onClose={() => {
            setOpenModal(false);
            setShouldAutoPrint(false);
          }}
          size="4xl"
        >
          <ModalHeader className="py-2 flex items-center">
            <span className="text-base">Visualizar consulta</span>
          </ModalHeader>
          <ModalBody className="bg-slate-50">
            <div style={{ zoom: "0.7" }} className="" ref={printRef}>
              <SelectedQueryReview
                dataFromLocalStorage={dataQuery}
                query={selectedQueryReview}
                onReady={() => {
                  if (shouldAutoPrint) {
                    reactToPrintFn();
                    setShouldAutoPrint(false);
                  }
                }}
              />
            </div>
          </ModalBody>
          <ModalFooter className="flex justify-center py-2 pb-3">
            <Button onClick={() => reactToPrintFn()}>Imprimir</Button>
            <Button color="gray" onClick={() => setOpenModal(false)}>
              Fechar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default ReportTable;
